import { useTimePilotT } from "@/i18n/useTimePilotT";
import React, { useEffect, useState, useContext } from 'react';
import { Time } from "@internationalized/date";
import { useAppFormatters } from "@/i18n/useAppFormatters";
import { getClientTimeFromStr } from '@/shared/functions';
import { Slide } from '@/shared/types';
import { XIcon, CheckIcon, ClockIcon, HourglassIcon } from "@phosphor-icons/react";
import { FeaturesContext } from '../../app/contexts';

const tzDisplay = (tz: string) => {
  if (!tz) {
    return '';
  }
  const tzStr = tz.split('/').join(' / ').replace(/_/g, ' ');
  return tzStr;
}

const Times = (props: { value: string, data: Slide }): JSX.Element => {
  const t = useTimePilotT();
  const { formatTime } = useAppFormatters();
  const [time, setTime] = useState<Time | null>(typeof props.value === 'string' ? getClientTimeFromStr(props.value) : null);
  const [timezone, setTimezone] = useState<string | null>(null);

  useEffect(() => {
    if (typeof props.value === 'string') {
      setTime(getClientTimeFromStr(props.value));
      if (props.data?.eventLocalTimezone) {
        setTimezone(props.data.eventLocalTimezone);
      }
    } else {
      setTime(null);
    }
  }, [props.data, props.value]);

  return (
    <div className="flex flex-row items-center justify-center">
      {!time && (
        <div className={`flex justify-right items-center`}>{t("viewers.notSpecified")}</div>
      )}
      {time && (
        <div className={`flex flex-col justify-right items-center`}>
          <div className="flex flex-row items-center justify-center gap-1">
            {props.data?.isTimeValid ? (
              <ClockIcon className="text-green-200 -mb-[14px]" size={14} weight="duotone" />
            ) : (
              <HourglassIcon className="text-yellow-500 -mb-[10px] opacity-0" size={1} weight="bold" />
            )}
            <div className="p-0 m-0 h-[14px]">
              {time ? formatTime(
                new Date(2025, 1, 1, time.hour, time.minute, time.second),
                { second: 'numeric' },
              ) : props.value}
            </div>
          </div>
          {timezone && (
            <div className="w-[85px] mt-[12px] break-words text-wrap leading-[16px]">
              {tzDisplay(timezone)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

Times.displayName = 'Times';

export default Times;
